// import {
//   useLazyGetCountryLevelQuery
// } from "store/services/publicApi";
import React, { useRef } from "react";
import Map, {
  NavigationControl,
  FullscreenControl,
  GeolocateControl,
  Source,
  Layer,
} from "react-map-gl";
import { Card, Typography } from "@mui/material";
import countryGeoData from "./countries.json";

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiYWlsZWVuYjE3IiwiYSI6ImNsMW9qZTF5bTA1NjMzcGtiMWV2cGF3bmkifQ.E4_tqWPBOUAYS8Z3-o-hUQ";

const RegionMapScreen = () => {
  const mapRef = useRef();

  const arr = [];
  countryGeoData?.features.forEach((item) => {
    const countryObj = {
      geometry: item?.geometry,
      properties: {
        region: item?.properties?.Province,
        regionName: item?.properties?.TARGET,
      },
    };
    arr.push(countryObj);
  });

  const allCountries = {
    type: "FeatureCollection",
    features: arr,
  };

  const countryLayer = {
    id: "country-layer",
    type: "fill",
    source: "region",
    paint: {
      "fill-color": {
        property: "region",
        stops: [
          [1, "green"],
          [2, "orange"],
          [3, "red"],
          [4, "blue"],
          [5, "yellow"],
          [6, "purple"],
          [7, "teal"],
        ],
      },
      "fill-opacity": 0.5,
    },
  };

  const labelLayer = {
    id: "label-layer",
    type: "symbol",
    source: "region",
    layout: {
      "text-field": ["get", "regionName"],
      "text-size": 12,
      "text-font": ["Open Sans Regular"],
    },
    paint: {
      "text-color": "#000000",
      "text-halo-color": "#FFFFFF",
      "text-halo-width": 1,
    },
  };

  const handleMapClick = (event) => {
    const features = event.features;
    if (features && features.length) {
      const clickedFeature = features[0];
      const { regionName } = clickedFeature.properties;

      alert(`Region: ${regionName}`);

      // Smooth zoom to the clicked feature
      const map = mapRef.current.getMap();
      const [longitude, latitude] = clickedFeature.geometry.coordinates[0][0];
      map.flyTo({
        center: [longitude, latitude],
        zoom: 7,
        essential: true,
      });
    }
  };

  return (
    <>
      <Typography gutterBottom variant="h6" component="div">
        Nepal Region Wise Division
      </Typography>

      <Card variant="outlined">
        <Map
          initialViewState={{
            longitude: 84,
            latitude: 28,
            zoom: 5,
          }}
          mapStyle="mapbox://styles/mapbox/light-v9"
          mapboxAccessToken={MAPBOX_TOKEN}
          ref={mapRef}
          id="adminMap"
          style={{ width: 1400, height: 600 }}
          attributionControl={false}
          interactiveLayerIds={["country-layer"]}
          onClick={handleMapClick}
        >
          <GeolocateControl position="top-right" />
          <FullscreenControl position="top-right" />
          <NavigationControl position="top-right" />
          <Source type="geojson" data={allCountries} id="region">
            <Layer {...countryLayer} />
            <Layer {...labelLayer} />
          </Source>
        </Map>
      </Card>
    </>
  );
};

export default RegionMapScreen;
